<template>
  <!-- 主播出走  v-if="roomInfo"-->
  <div class="live-away">
    <!-- <div class="live-away-title">{{roomInfo.title}}</div> -->
    <div class="live-away-txt">Wait a moment please ~</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "live-away",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      roomInfo: "getRoomInfo",
    }),
  },
  created() {
    console.log('this.roomInfo',this.roomInfo);
  } 
};
</script>

<style scoped lang="scss">
.live-away {
  width: 100vw;
//   top: 27%;
  left: 0;
  position: absolute;
  z-index: 98;
  text-align: center;
  color: #fff;
  height: 100%;
  background: rgba(0,0,0,.4);
}

.live-away-title {
  font-size: 0.48rem;
  margin:0 auto 0.56rem;
}

.live-away-txt {
  font-size: 0.3rem;
  margin-bottom: 0.42rem;
  margin-top: 2rem;
}

</style>
